const filterByOperationDefinition = (items) =>
  items.filter(
    (definition) => definition.kind === "OperationDefinition" && definition.name
  );

const getOperationName = (document) => {
  if (document && document.definitions && document.definitions.length) {
    const definitionsFiltered = filterByOperationDefinition(
      document.definitions
    );

    if (definitionsFiltered.length) {
      return (
        definitionsFiltered.map((definition) => definition.name.value)[0] ||
        null
      );
    }
  }
  return null;
};

const getSelectionSetName = (document) => {
  if (document && document.definitions && document.definitions.length) {
    const definitionsFiltered = filterByOperationDefinition(
      document.definitions
    );

    if (definitionsFiltered.length) {
      return definitionsFiltered.reduce((result, current) => {
        if (
          current &&
          current.selectionSet &&
          current.selectionSet.selections &&
          current.selectionSet.selections.length
        ) {
          const names = current.selectionSet.selections.reduce(
            (subResult, subCurrent) =>
              subCurrent && subCurrent.name && subCurrent.name.value
                ? [...subResult, subCurrent.name.value]
                : subResult,
            []
          );
          return [...result, names];
        }
        return result;
      }, []);
    }
  }
  return null;
};

export { getOperationName, getSelectionSetName, filterByOperationDefinition };
